// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"7":"c944147ec73b00dec533","96":"084d00ae1d81674da561"}[chunkId] + ".js";
};